"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var Checkbox_1 = __importDefault(require("@/Components/common/Checkbox"));
var IntegrationEditor_module_css_1 = __importDefault(require("./IntegrationEditor.module.css"));
var AjaxProvider_1 = __importDefault(require("@/functions/AjaxProvider"));
var q_play_core_1 = require("@nordicscreen/q-play-core");
var GenericSnackbar_1 = __importDefault(require("../GenericSnackbar"));
var react_i18next_1 = require("react-i18next");
var IntegrationTemplateInfoTab = function (_a) {
    var integrationTemplateData = _a.integrationTemplateData, onSave = _a.onSave;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _b = (0, react_1.useState)(integrationTemplateData.name || ""), templateName = _b[0], setTemplateName = _b[1];
    var _c = (0, react_1.useState)(integrationTemplateData.description || ""), description = _c[0], setDescription = _c[1];
    var _d = (0, react_1.useState)(integrationTemplateData.description_link || ""), descriptionLink = _d[0], setDescriptionLink = _d[1];
    var _e = (0, react_1.useState)(integrationTemplateData.setup_quick_guide || ""), setupQuickGuide = _e[0], setSetupQuickGuide = _e[1];
    var _f = (0, react_1.useState)(integrationTemplateData.public), isPublic = _f[0], setIsPublic = _f[1];
    var _g = (0, react_1.useState)(integrationTemplateData.visible), isVisible = _g[0], setIsVisible = _g[1];
    var _h = (0, react_1.useState)(false), isSaving = _h[0], setIsSaving = _h[1];
    var logger = q_play_core_1.logManager.getLogger();
    var _j = (0, react_1.useState)(false), snackbarOpen = _j[0], setSnackbarOpen = _j[1];
    var _k = (0, react_1.useState)(""), snackbarMessage = _k[0], setSnackbarMessage = _k[1];
    var _l = (0, react_1.useState)("success"), snackbarSeverity = _l[0], setSnackbarSeverity = _l[1];
    (0, react_1.useEffect)(function () {
        setTemplateName(integrationTemplateData.name || "");
        setDescription(integrationTemplateData.description || "");
        setDescriptionLink(integrationTemplateData.description_link || "");
        setSetupQuickGuide(integrationTemplateData.setup_quick_guide || "");
        setIsPublic(integrationTemplateData.public);
        setIsVisible(integrationTemplateData.visible);
    }, [integrationTemplateData]);
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var dataProvider, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, 4, 5]);
                    setIsSaving(true);
                    dataProvider = (0, AjaxProvider_1.default)("/api");
                    return [4 /*yield*/, dataProvider.updateIntegrationTemplate(integrationTemplateData.id, {
                            name: templateName,
                            description: description,
                            description_link: descriptionLink,
                            setup_quick_guide: setupQuickGuide,
                            public: isPublic,
                            visible: isVisible,
                        })];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, onSave(templateName, description, descriptionLink, setupQuickGuide, isPublic, isVisible)];
                case 2:
                    _a.sent();
                    setSnackbarSeverity("success");
                    setSnackbarMessage(t("Integration template updated successfully"));
                    setSnackbarOpen(true);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    logger.error("Error saving integration template info:", error_1);
                    setSnackbarSeverity("error");
                    setSnackbarMessage(t("Failed to update integration template"));
                    setSnackbarOpen(true);
                    return [3 /*break*/, 5];
                case 4:
                    setIsSaving(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: IntegrationEditor_module_css_1.default["info-tab-container"] },
            react_1.default.createElement("div", { className: IntegrationEditor_module_css_1.default["info-tab-content"] },
                react_1.default.createElement("div", { className: IntegrationEditor_module_css_1.default["form-group"] },
                    react_1.default.createElement("label", { className: IntegrationEditor_module_css_1.default["template-info-label"] }, "Name:"),
                    react_1.default.createElement(q_play_components_1.Input, { type: "text", value: templateName, onChange: function (e) { return setTemplateName(e.target.value); }, style: {
                            fontSize: "14px",
                            padding: "8px",
                            boxSizing: "border-box",
                        } })),
                react_1.default.createElement("div", { className: IntegrationEditor_module_css_1.default["form-group"] },
                    react_1.default.createElement("label", { className: IntegrationEditor_module_css_1.default["template-info-label"] }, "Description:"),
                    react_1.default.createElement(q_play_components_1.Input, { type: "text", value: description, onChange: function (e) { return setDescription(e.target.value); }, style: {
                            fontSize: "14px",
                            padding: "8px",
                            boxSizing: "border-box",
                        } })),
                react_1.default.createElement("div", { className: IntegrationEditor_module_css_1.default["form-group"] },
                    react_1.default.createElement("label", { className: IntegrationEditor_module_css_1.default["template-info-label"] }, "Description Link:"),
                    react_1.default.createElement(q_play_components_1.Input, { type: "text", value: descriptionLink, onChange: function (e) { return setDescriptionLink(e.target.value); }, style: {
                            fontSize: "14px",
                            padding: "8px",
                            boxSizing: "border-box",
                        } })),
                react_1.default.createElement("div", { className: IntegrationEditor_module_css_1.default["form-group"] },
                    react_1.default.createElement("label", { className: IntegrationEditor_module_css_1.default["template-info-label"] }, "Setup Quick Guide:"),
                    react_1.default.createElement(q_play_components_1.Input, { type: "text", value: setupQuickGuide, onChange: function (e) { return setSetupQuickGuide(e.target.value); }, style: {
                            fontSize: "14px",
                            padding: "8px",
                            boxSizing: "border-box",
                        } })),
                react_1.default.createElement("div", { className: IntegrationEditor_module_css_1.default["template-info-checkbox"] },
                    react_1.default.createElement("label", { className: IntegrationEditor_module_css_1.default["template-info-label"] }, "Visible:"),
                    react_1.default.createElement(Checkbox_1.default, { checked: isVisible, onChange: function () { return setIsVisible(!isVisible); } })),
                react_1.default.createElement("div", { className: IntegrationEditor_module_css_1.default["template-info-checkbox-second"] },
                    react_1.default.createElement("label", { className: IntegrationEditor_module_css_1.default["template-info-label"] }, "Public:"),
                    react_1.default.createElement(Checkbox_1.default, { checked: isPublic, onChange: function () { return setIsPublic(!isPublic); } })),
                react_1.default.createElement("div", { className: IntegrationEditor_module_css_1.default["save-button-wrapper"] },
                    react_1.default.createElement(q_play_components_1.Button, { text: "Save", onClick: handleSave, disabled: isSaving })))),
        react_1.default.createElement(GenericSnackbar_1.default, { open: snackbarOpen, onClose: function () { return setSnackbarOpen(false); }, message: snackbarMessage, severity: snackbarSeverity, snackbarStyle: {
                marginLeft: "110px",
            } })));
};
exports.default = IntegrationTemplateInfoTab;
